module.exports = __webpack_public_path__ + "img/ic_plus.370a8ae5.svg";